
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientCompanyProposalSettingsResource,
  ProposalValidationSettingsUpdateRequest,
} from '../models';
import {
    ClientCompanyProposalSettingsResourceFromJSON,
    ClientCompanyProposalSettingsResourceToJSON,
    ProposalValidationSettingsUpdateRequestFromJSON,
    ProposalValidationSettingsUpdateRequestToJSON,
} from '../models';

export interface GetProposalSettingsRequest {
    companyId: string;
}

export interface UpdateValidationSettingsRequest {
    companyId: string;
    proposalValidationSettingsUpdateRequest: ProposalValidationSettingsUpdateRequest;
}

/**
 * 
 */
export class ClientCompanyProposalSettingsApi extends runtime.BaseAPI {

    /**
          */
    async getProposalSettingsRaw(requestParameters: GetProposalSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyProposalSettingsResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getProposalSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanyProposalSettingsResource>({
            path: `/client-settings/api/{companyId}/proposal`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyProposalSettingsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getProposalSettings(requestParameters: GetProposalSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyProposalSettingsResource> {
        const response = await this.getProposalSettingsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateValidationSettingsRaw(requestParameters: UpdateValidationSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyProposalSettingsResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateValidationSettings().'
            );
        }

        if (requestParameters['proposalValidationSettingsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'proposalValidationSettingsUpdateRequest',
                'Required parameter "proposalValidationSettingsUpdateRequest" was null or undefined when calling updateValidationSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientCompanyProposalSettingsResource>({
            path: `/client-settings/api/{companyId}/proposal`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProposalValidationSettingsUpdateRequestToJSON(requestParameters['proposalValidationSettingsUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyProposalSettingsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateValidationSettings(requestParameters: UpdateValidationSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyProposalSettingsResource> {
        const response = await this.updateValidationSettingsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
